import { useCallback, useEffect, useState } from 'react';
import ReactMapGL from 'react-map-gl';
import { AxiosResponse } from 'axios';

//components
import { Img } from '../../../component/img/Img';
import MapMarker from '../../../component/mapMarker/MapMarker';

//assets
import StreetView from '../../../assets/icon/StreetView.svg';
import StoreIcon from '@material-ui/icons/Store';

//services
import api from '../../../services/api';
import MapPopup from '../../../component/mapPopup/MapPopup';
import { Devider, Label, Title, TitleLinkSmall } from './Map.styles';

//styles map
const STYLE_MAP: any = require("./map-style-basic-v8.json");

interface Info {
  name: string,
  group: string,
  latitude: number,
  longitude: number,
  address: string,
  type:  "TECH" | "STORE"
}

function Map() {
  const [tecs, setTecs] = useState<TechnicianResponse[]>([]);
  const [stores, setStores] = useState<StoreResponse[]>([]);
  const [showPopup, setShowPopup] = useState(false);
  const [infoData, setInfoData] = useState<Info | null>(null);

  const [viewport, setViewport] = useState({
    width: "calc(100vw - 116px)",
    height: "90vh",
    latitude: -10.945982184343203,
    longitude: -37.06128397869639,
    zoom: 11
  });


  const getData = useCallback( async () => {
    const responseTecs: AxiosResponse<TechnicianResponse[]> = await api.get('/tecs');
    const responseStores: AxiosResponse<StoreResponse[]> = await api.get('/stores');

    if (responseTecs.data && responseTecs.data.length)
      setTecs(responseTecs.data.filter( (tec: TechnicianResponse) => (tec.status !== 0) ));
    if (responseStores.data && responseTecs.data.length)
      setStores(responseStores.data);
      
  }, [setTecs, setStores]);


  useEffect(() => {
    getData();
  }, [getData])

  
  const onChangeInfo = (info: any, type: "TECH" | "STORE") => setInfoData({
    name: info.name, 
    group: info.group,
    latitude: info.location.coordinates[1],
    longitude: info.location.coordinates[0],
    address: (type === "STORE") ? info.address : "",
    type
  });


  return (
    <ReactMapGL 
        {...viewport}
        mapStyle={STYLE_MAP}
        mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}
        onViewportChange={ (nextViewport: any) => setViewport(nextViewport) }>
        {
          tecs.map( (tech: TechnicianResponse, i: number) => (
            <MapMarker  
                key={`tec-marker-map-${i}`}
                latitude={tech.location.coordinates[1]}
                longitude={tech.location.coordinates[0]}
                onClick={() => {
                  onChangeInfo(tech, "TECH"); 
                  setShowPopup(true);
                }}
                icon={<Img src={StreetView} style={{width: 30, height: 30}}/>} />
          ))
        }
        {
          stores.map( (store: StoreResponse, i: number) => (
            <MapMarker  
                key={`store-marker-map-${i}`}
                latitude={store.location.coordinates[1]}
                longitude={store.location.coordinates[0]}
                onClick={() => {
                  onChangeInfo(store, "STORE")
                  setShowPopup(true);
                }} 
                icon={<StoreIcon style={{width: 30, height: 30, color: "#2b6cb0"}}/>} />
          ))
        }
        {
          infoData ? (
            <MapPopup
              show={showPopup}
              latitude={infoData?.latitude}
              longitude={infoData?.longitude}
              onClose={() => setInfoData(null)}
            >
              {
                infoData.type === "STORE" ? (
                <>
                  <Label>Loja:</Label>
                  <Title>{infoData.name}</Title>
                  <Devider/>
                  <Label>Grupo:</Label>
                  <Title>{infoData.group}</Title>
                  <Devider/>
                  <Label>Endereço:</Label>
                  <TitleLinkSmall target="_new" href={`https://www.google.com.br/maps/place/${infoData.address}`}>{infoData.address}</TitleLinkSmall>
                </>
                ) : (
                <>
                  <Label>Técnico:</Label>
                  <Title>{infoData.name}</Title>
                  <Devider/>
                  <Label>Grupo:</Label>
                  <Title>{infoData.group}</Title>
                </>
                )
              }
            </MapPopup>
          ) : <></>
        }
    </ReactMapGL>
  );
}

export default Map;